import React from "react";
import TerminalDatatable from "./TerminalManagement/TerminalDatatable";
import Select from "react-select";
import TerminalTabs from "./TerminalManagement/TerminalTabs";
import TerminalDetailsTabs from "./TerminalManagement/TerminalDetailsTab";

function TerminalDashboard(props) {
  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <TerminalTabs terminalsData={props.terminalsData}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TerminalDashboard;

